/**
 * legal-info.ts — Thông tin đơn vị vận hành hiển thị ở các trang pháp lý công khai
 * (/dieu-khoan, /chinh-sach-bao-mat, /xoa-du-lieu).
 *
 * Trường để `null` thì dòng đó tự ẩn — KHÔNG điền giá trị đoán. Meta (xin Live app) và người dùng cần
 * thông tin liên hệ THẬT: điền đủ trước khi nộp URL cho Meta.
 *
 * i18n-ignore-file — tên pháp nhân + địa chỉ đúng như giấy đăng ký kinh doanh, KHÔNG dịch theo ngôn ngữ UI.
 */
export const LEGAL_INFO = {
  /** Tên sản phẩm. */
  product: 'eCDP',
  /** Tên pháp nhân vận hành (đúng như giấy đăng ký kinh doanh). */
  companyName: 'CÔNG TY CỔ PHẦN CÔNG NGHỆ EVO' as string | null,
  /** Tên giao dịch tiếng Anh. */
  companyNameEn: 'EVO TECHNOLOGY JOINT STOCK COMPANY' as string | null,
  /** Địa chỉ trụ sở. */
  address: 'TT6.2b - 61 Khu đô thị mới Đại Kim, Phường Định Công, Quận Hoàng Mai, Thành phố Hà Nội' as string | null,
  /** Mã số thuế / mã số doanh nghiệp. */
  taxId: '0110956888' as string | null,
  /** Email nhận yêu cầu về dữ liệu cá nhân + hỗ trợ (cũng điền vào "Email liên hệ" của Meta App). */
  email: 'contact@ecdp.vn' as string | null,
  /** Số điện thoại hỗ trợ. */
  phone: '0867223332' as string | null,
  /** Ngày hiệu lực của bộ văn bản. */
  effectiveDate: '12/10/2026',
}

export type LegalInfo = typeof LEGAL_INFO
